module.exports = __webpack_public_path__ + "img/lv1.7b566a50.png";